import {IPlatformApiProvider} from '@shared/services/platform-api-provider';

export class FileStoreApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/orbitax-repository') || url.startsWith('/drive') || url.startsWith('/orbitax-drive')) {
      return 'FileStoreApi';
    }
    return '';
  }

}
